/* esm.sh - applesauce-core@5.2.0/helpers/model */
export * from "/*applesauce-core@5.2.0/esnext/helpers/model.mjs";
